import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { IAppState } from '../../store/app.state';
import { selectBeneficiariosList } from '../../store/selectors/beneficiarios.selectors';
import { IBeneficiario, ICreateBeneficiario, IUpdateBeneficiario } from '../../interfaces/beneficiarios.interface';
import { selectCentrosList } from '../../store/selectors/centros.selectors'
import { ICentro, ICreateCentro, IUpdateCentro } from '../../interfaces/centros.interface';
import { ICreateGrupo, IGrupo, IUpdateGrupo } from '../../interfaces/grupos.interface';
import { selectGruposList } from '../../store/selectors/grupos.selectors';
import { Actions, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';
import {
  CreateBeneficiario, CreateBeneficiarioSuccess, DeleteBeneficiario, DeleteBeneficiarioSuccess,
  GetBeneficiarios, UpdateBeneficiario, UpdateBeneficiarioSuccess
} from '../../store/actions/beneficiarios.actions';
import {
  CreateCentro, CreateCentroSuccess, DeleteCentro, DeleteCentroSuccess,
  GetCentros, UpdateCentro, UpdateCentroSuccess
} from '../../store/actions/centros.actions';
import {
  CreateGrupo, CreateGrupoSuccess, DeleteGrupo, DeleteGrupoSuccess,
  GetGrupos, UpdateGrupo, UpdateGrupoSuccess
} from '../../store/actions/grupos.actions';
import { AuthenticationService } from '../../services/authentication.service';
import { selectFormularioResponsesList, selectFormulariosList } from 'src/app/store/selectors/formularios.selectors';
import { GetFormularioResponses, GetFormularios } from 'src/app/store/actions/formularios.actions';
import { ExportExcelService } from 'src/app/services/export-excel.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  beneficiarios = this.store$.pipe(
    select(selectBeneficiariosList)
  );

  centros = this.store$.pipe(
    select(selectCentrosList)
  );

  grupos = this.store$.pipe(
    select(selectGruposList)
  );

  responses = this.store$.pipe(
    select(selectFormularioResponsesList)
  ).subscribe(data => {
    this.formData = [];
    this.dataToParse = data;

    data.map(dataCheck => {
      const fields = { ...dataCheck };

      for (const field of fields.responses[0]) {
        this.formData.push({ name: field });
      }

      this.formData = [...this.formData];
    })
  });

  formularios = this.store$.pipe(
    select(selectFormulariosList),
    map(formularios => formularios.map(formulario => {
      return { label: formulario.titulo, value: formulario }
    }))
  );

  dateIni = new Date();
  dateFin = new Date();
  selectedComunity: any;
  selectedSample: any;
  samples = [];
  display = false;
  header = '';
  SelectedFormulario: any;
  formData = [];
  selectedFields: any;
  title = 'angular-export-to-excel';
  dataForExcel = [];
  formsExcel = [];
  dataToParse: any;
  empPerformance = [
    { ID: 10011, NAME: 'A', DEPARTMENT: 'Sales', MONTH: 'Jan', YEAR: 2020, SALES: 132412, CHANGE: 12, LEADS: 35 },
    { ID: 10012, NAME: 'A', DEPARTMENT: 'Sales', MONTH: 'Feb', YEAR: 2020, SALES: 232324, CHANGE: 2, LEADS: 443 },
    { ID: 10013, NAME: 'A', DEPARTMENT: 'Sales', MONTH: 'Mar', YEAR: 2020, SALES: 542234, CHANGE: 45, LEADS: 345 },
    { ID: 10014, NAME: 'A', DEPARTMENT: 'Sales', MONTH: 'Apr', YEAR: 2020, SALES: 223335, CHANGE: 32, LEADS: 234 },
    { ID: 10015, NAME: 'A', DEPARTMENT: 'Sales', MONTH: 'May', YEAR: 2020, SALES: 455535, CHANGE: 21, LEADS: 12 },
  ];

  constructor(
    private store$: Store<IAppState>,
    private actions$: Actions,
    private authService: AuthenticationService,
    private ete: ExportExcelService,
    private router: Router,
  ) {

    if(this.authService.currentTokenValue === 'publicToken') {
      this.router.navigate(['/instituciones']);
    }

    this.samples = [
      { sample: 'En Cursos' },
      { sample: 'Graduados' }
    ];

    this.store$.dispatch(GetCentros());
    this.store$.dispatch(GetGrupos());
    this.store$.dispatch(GetBeneficiarios());
    this.store$.dispatch(GetFormularios());
  }

  async ngOnInit() {
    const currentToken = this.authService.currentTokenValue;
  }

  displayReportes() {
    this.header = 'Reportes'
    this.formData = null;
    this.display = true;
  }

  exportToExcel() {
    const tempArray = [];
    const arrayToSend = [];
    let tempArray2 = [];

    for (const field of this.selectedFields) {
      tempArray.push(this.dataToParse[0].responses[0].indexOf(field.name));
    }

    let tempData: any;

    for (let i = 0; i < Object.keys(this.dataToParse[0].responses).length; i++) {
      tempData = this.dataToParse[0].responses[i];

      for (const index of tempArray) {
        tempArray2.push(tempData[index]);
      }

      arrayToSend.push(tempArray2);
      tempArray2 = [];
    }

    this.formsExcel.forEach((row: any) => {
      this.dataForExcel.push(Object.values(row))
    })

    const reportData = {
      title: 'Reportes Formularios',
      data: arrayToSend,
      headers: arrayToSend[0]
    }

    this.ete.exportExcel(reportData, true);
  }

  reportes() {
    this.store$.dispatch(GetFormularioResponses({ id: this.SelectedFormulario.spreadsheetId }))
  }
}
